import React, { Suspense, lazy, useEffect, useRef, useState } from 'react';
import SectionTitle from './SectionTitle';
import pongiste from '../assets/img/webp/pongiste.webp';

// Leaflet (~150 Ko) n'est chargé que lorsque la carte approche du viewport.
const Maps = lazy(() => import('./Maps'));

const CRENEAUX = [
  { jour: 'Mercredi', heure: '19h30 – 22h00' },
  { jour: 'Vendredi', heure: '18h30 – 21h00' },
  { jour: 'Samedi', heure: '14h00 – 16h30' },
];

function InfoPratique() {
  const sectionRef = useRef(null);
  const mapZone = useRef(null);
  const [showMap, setShowMap] = useState(false);
  const [revealed, setRevealed] = useState(false);

  // Charge la carte quand elle approche du viewport.
  useEffect(() => {
    if (showMap || !mapZone.current) return;
    if (typeof IntersectionObserver === 'undefined') {
      setShowMap(true);
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setShowMap(true);
          observer.disconnect();
        }
      },
      { rootMargin: '300px' }
    );
    observer.observe(mapZone.current);
    return () => observer.disconnect();
  }, [showMap]);

  // Les silhouettes n'apparaissent (en fondu) qu'une fois qu'on a scrollé jusqu'à
  // la section : déclenché quand son haut a franchi ~70 % de la hauteur d'écran.
  useEffect(() => {
    if (revealed || !sectionRef.current) return;
    if (typeof IntersectionObserver === 'undefined') {
      setRevealed(true);
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setRevealed(true);
          observer.disconnect();
        }
      },
      { threshold: 0, rootMargin: '0px 0px -30% 0px' }
    );
    observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, [revealed]);

  return (
    <section
      id="infos-pratiques"
      ref={sectionRef}
      className={`section section--seam section--pink infos-pratiques ${revealed ? 'is-revealed' : ''}`}
    >
      <img
        src={pongiste}
        alt=""
        aria-hidden="true"
        className="pongiste-silhouette"
        width="820"
        height="1230"
        loading="lazy"
        decoding="async"
      />

      <SectionTitle overline="Infos pratiques" className="on-dark">
        Où et quand jouer&nbsp;?
      </SectionTitle>

      <div className="infos-pratiques-grid">
        <div className="info-card">
          <h3>Adresse</h3>
          <p>
            Vieux gymnase des Garcins
            <br />
            Albert Bourges
            <br />
            05100 Briançon, France
          </p>
        </div>

        <div className="info-card">
          <h3>Créneaux de jeu</h3>
          <ul className="creneaux">
            {CRENEAUX.map(({ jour, heure }) => (
              <li key={jour}>
                <span className="jour">{jour}</span>
                <span className="heure">{heure}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="info-card map-card" ref={mapZone}>
          {showMap && (
            <Suspense fallback={<div className="map-placeholder" aria-hidden="true" />}>
              <Maps />
            </Suspense>
          )}
        </div>
      </div>
    </section>
  );
}

export default InfoPratique;
